<template>
  <a-card :bordered="false">
    <CustomCrumbs :data-list="crumbsList" show-name="title"></CustomCrumbs>
    <div style="height: 20px"></div>
    <a-form-model ref="form" :model="proForm" :rules="proRules" :label-col="{span:4}" :wrapper-col="{span:20}">
      <a-form-model-item
        label="商品标题"
        prop="productName">
        <a-input style="max-width: 600px;" v-model="proForm.productName" placeholder="请输入" :maxLength="50"></a-input>
      </a-form-model-item>
      <a-form-model-item
        label="售价"
        prop="productSalePrice">
        <a-input style="max-width: 600px;" v-model="proForm.productSalePrice" placeholder="请输入">
          <span slot="addonAfter">元</span>
        </a-input>
      </a-form-model-item>
      <a-form-model-item
        label="分销佣金"
        prop="productCommission">
        <a-input style="max-width: 600px;" v-model="proForm.productCommission" placeholder="请输入" type="digit">
          <span slot="addonAfter">元</span>
        </a-input>
      </a-form-model-item>
      <a-form-model-item
        label="库存"
        prop="productStock">
        <a-input style="max-width: 600px;" v-model="proForm.productStock" placeholder="请输入"></a-input>

      </a-form-model-item>
      <a-form-model-item
        label="所属仓号"
        prop="productSeat">
        <a-select
          v-model="proForm.productSeat"
          allowClear
          style="max-width: 600px;"
          placeholder="请选择仓号">
          <a-select-option value="1">1</a-select-option>
          <a-select-option value="2">2</a-select-option>
          <a-select-option value="3">3</a-select-option>
          <a-select-option value="4">4</a-select-option>
          <a-select-option value="5">5</a-select-option>
          <a-select-option value="6">6</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="商品详情"
        prop="productDes">
        <CustomUeditor v-model="proForm.productDes" style="width: 600px"></CustomUeditor>
      </a-form-model-item>
      <a-form-model-item
        label="封面图"
        prop="productImg">
        <custom-upload-pro-images
          v-model="proForm.productImg"
          :multiple-selected="false"
          :maxCount="1"
          tips="请选择封面图"
          :draggableUpdate="false"></custom-upload-pro-images>
      </a-form-model-item>
      <a-form-model-item
        label="状态"
        :colon="false"
        :required="false"
        prop="productStatus">
        <a-select
          v-model="proForm.productStatus"
          :disabled="false"
          style="width: 600px"
          placeholder="请选择"
        >
          <a-select-option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.key }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label=" "
        :colon="false"
        :required="false"
      >
        <a-button type="primary" @click="submitEvent" :loading="submitLoading">提交</a-button>
        <a-button style="margin-left: 20px" @click="backEvent()">取消</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import smartMixins from '../smartMixins'
import CustomCrumbs from '../../../../../customComponents/CustomCrumbs'
import CustomUeditor from '@/customComponents/CustomUeditor/CustomUeditor'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'

export default {
  name: 'VmProductEditor',
  components: { CustomCrumbs, CustomUeditor, CustomUploadProImages },
  mixins: [smartMixins],
  data() {
    return {
      submitLoading: false,
      crumbsList: [
        {
          title: '无人售货机(客房版)'
        },
        {
          title: '商品管理',
          routeName: 'VmProductManager'
        },
        {
          title: '编辑商品'
        }
      ],
      statusList: [
        {
          value: 0,
          key: '未投放'
        },
        {
          value: 1,
          key: '已投放'
        }
      ],
      proForm: {
        productDes: '',
        productCommission: 0
      },
      proRules: {
        productName: [
          { required: true, message: '请输入商品标题', trigger: ['blur', 'change'] }
        ],
        productImg: [
          { required: true, message: '请上传商品封面图', trigger: ['blur', 'change'] }
        ],
        productSalePrice: [
          { required: true, message: '请输入销售价', trigger: ['blur', 'change'] },
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        productCommission: [
          { required: false, message: '请输入分销佣金', trigger: ['blur', 'change'] },
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: this.validatorProductCommission, trigger: ['blur', 'change'] }

        ],
        productStock: [
          { required: true, message: '请输入库存', trigger: ['blur', 'change'] },
          // { pattern: /^[0-9]\d{0,5}$/, message: '请输入正确的库存', trigger: 'blur' }
          { pattern: /^-?\d+$/, message: '请输入正确的库存', trigger: 'blur' }
        ],
        productSeat: [
          { required: true, message: '请输入仓号', trigger: ['blur', 'change'] },
          { pattern: /^[1-6]$/, message: '请输入正确的仓号', trigger: 'blur' }
        ],
        productDes: [
          { required: true, message: '请输入商品详情', trigger: ['blur', 'change'] }
        ],
        productStatus: [
          { required: true, message: '请选择商品状态', trigger: ['blur', 'change'] }
        ]
      },
      productId: ''

    }
  },
  watch: {
    'productId': function(newVal, oldVal) {
      this.proForm = { productDes: '', productCommission: 0 }
      this.getProDetails(this.productId)
    }
  },

  mounted() {
    this.merchantId = this.$store.getters.userInfo.merchantId
    this.platformId = this.getPlatformConfig().platformId
    this.productId = this.getPageParams().productId
  },
  activated() {
    this.productId = this.getPageParams().productId
    if (!this.productId) {
      this.proForm = { productDes: '', productCommission: 0 }
    }
  },
  methods: {
    validatorProductCommission(rule, value, callback) {
      if (this.proForm.productCommission < this.proForm.productSalePrice) {
        callback()
      } else {
        callback(new Error('佣金必须小于销售价格！'))
      }
    },
    getProDetails(proId) {
      if (proId) {
        this.getHttpServices().getServerApiService().get('/iot/vem/findVemProduct', { productId: proId })
          .then(details => {
            this.proForm = {
              ...details,
              productCommission: details.productCommission ? details.productCommission : 0,
              productImg: details.productImg ? [details.productImg] : []
            }
            this.getLogUtils().logWithTag('getProDetails', details)
          }).catch(reason => {
          this.showNetWorkErrorMessage(reason)
          this.getLogUtils().errorWithTag('getProDetails', reason)
        })
      } else {
        this.proForm = { productDes: '', productCommission: 0 }
      }
    },
    submitEvent() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.updateProDetails()
        } else {
          this.$message.error('请完善表单信息')
        }
      })
    },

    updateProDetails() {
      this.submitLoading = true
      const requestParams = {
        baseDto: {
          merchantId: this.merchantId,
          platformId: this.platformId
        },
        ...this.proForm,
        productImg: this.proForm.productImg.length > 0 ? this.proForm.productImg[0] : ''
      }
      this.getHttpServices().getServerApiService().post('/iot/vem/editVemProduct', requestParams)
        .then(res => {
          this.getLogUtils().logWithTag('editVemProduct', res)
          let tips = this.productId ? '编辑成功' : '新增成功'
          this.$message.success(tips)
          setTimeout(() => this.backEvent(), 1500)
        }).catch(reason => {
        this.getLogUtils().errorWithTag('editVemProduct', reason)
        this.showNetWorkErrorMessage(reason)
      }).finally(() => this.submitLoading = false)
    }
  }

}
</script>
<style scoped>
</style>